<div>
  <el-container>
    <el-header class="header" height="80px">
      <div class="header-container">
        <a href="https://тк-луч.рф/">
          <img src="@/assets/logo.png" class="logo" alt="" />
        </a>
        <span>
          Ежедневная срочная <br />
          доставка груза
        </span>
      </div>
      <nav>
        <div class="links">
          <router-link class="navLink" active-class="active-link" :to="{name: 'calculator'}">Калькулятор</router-link>
          <router-link class="navLink" @click="dataForm.$reset()" active-class="active-link" :to="{name: 'cargoPickup'}">Оформление груза</router-link>
          <router-link class="navLink" @click="dataForm.$reset()" active-class="active-link" :to="{name: 'cargoStatus'}">Статус груза</router-link>
        </div>
      </nav>
    </el-header>
    <router-view />
  </el-container>
</div>
